import { render, staticRenderFns } from "./MagicSpinner.vue?vue&type=template&id=5befeaa0&scoped=true&"
import script from "./MagicSpinner.vue?vue&type=script&lang=js&"
export * from "./MagicSpinner.vue?vue&type=script&lang=js&"
import style0 from "./MagicSpinner.vue?vue&type=style&index=0&id=5befeaa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5befeaa0",
  null
  
)

export default component.exports